import { SocialComponents } from 'be-components';
import React, { useEffect, useState } from 'react';
import { View } from "react-native"
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Colors from '../../constants/Colorsv2';
import { ArticleProps, PodcastProps } from '../../store/types/soc_svc';
import { useDispatch } from 'react-redux';
import { util_updateShare } from '../../store/actionsv1/utils';
import { company_getCompanyByIdNoStore } from '../../store/actionsv1/player';
import { Helmet } from "react-helmet-async";


const CompanyScreen = ({ route, navigation }:any) => {
    const [ company, setCompany ] = useState<any>(undefined)
    const insets = useSafeAreaInsets();
    const dispatch = useDispatch();

    useEffect(() => {
        getCompanyFromServer(route.params.company_id)
    },[route.params.company_id]);

    const getCompanyFromServer = async(id:string) => {
        const c = await company_getCompanyByIdNoStore(id)
        setCompany(c);
    }


    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            {company ?
            <Helmet>
                <title>{company.company_name}</title>
                <meta name='description' content={`Engage with ${company.company_name} on BettorEdge`}/>
                <meta name='og:image' content={company.company_image?.url} />
            </Helmet>
            :<></>}
            <SocialComponents.CompanyProfile
                company_id={route.params.company_id}
                padding_insets={insets}
                onSelectPlayer={(p) => navigation.push('SocialProfile', { player_id:p.player_id })}
                onSelectBracketCompetition={(bc) => navigation.navigate('CompetitionStack', { screen: 'BracketPlay', inital:false, params: { bracket_competition_id: bc.bracket_competition_id } })}
                onSelectCompetition={(bc) => navigation.navigate('CompetitionStack', { screen: 'CompetitionPlay', inital:false, params: { competition_id: bc.competition_id } })}
                onSelectSquaresCompetition={(bc) => navigation.navigate('CompetitionStack', { screen: 'SquaresPlay', inital:false, params: { sq_comp_id: bc.sq_comp_id } })}
                onArticleSelect={(article:ArticleProps) => {
                    if(article.url){ return window.open(article.url, '_blank') }
                }}
                onShareCompany={(co) => {
                    dispatch(util_updateShare({
                        share_key: `comp_${co.company_id}_share`,
                        visible:true,
                        title: `Checkout ${co.company_name} on BettorEdge`,
                        body: `${co.company_description}`,
                        type_id: co.company_id,
                        generator:'player',
                        link_type: 'user_generated_link',
                        link_sub_type: 'room_link',
                        redirect_url: `https://app.bettoredge.com/social/company/${co.company_id}`,
                    }))
                }}
                onSelectPodcast={(pod:PodcastProps) => navigation.push('PodcastEpisodes', { podcast_id: pod.podcast_id })}
                onBack={() => navigation.goBack()}
            />
        </View>
    )
}

export default CompanyScreen